module.exports = __webpack_public_path__ + "static/media/linde-logo@2x.0cb3095b.png";